<template>
  <router-view />
</template>

<script>
export default {
  name: 'LabLayout'
}
</script>
